import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import scaleToFontSize from '../scaleToFontSize/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var abs = Math.abs,
    ceil = Math.ceil,
    round = Math.round;
var defaultScale = 1;
var changeScaleToFontSize = function changeScaleToFontSize(attrs) {
  var scaleX = abs(attrs.scaleX || defaultScale);
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    scaleY: defaultScale,
    scaleX: defaultScale,
    fontSize: round(scaleToFontSize(scaleX, attrs.fontSize))
  }, attrs.padding && {
    padding: attrs.padding * scaleX
  }), attrs.width && {
    width: ceil(attrs.width * scaleX)
  }), attrs.lineHeight && {
    lineHeight: attrs.lineHeight * scaleX
  }), attrs.strokeWidth && {
    strokeWidth: attrs.strokeWidth * scaleX
  }), attrs.shadowOffsetX && {
    shadowOffsetX: attrs.shadowOffsetX * scaleX
  }), attrs.shadowOffsetY && {
    shadowOffsetY: attrs.shadowOffsetY * scaleX
  }), attrs.letterSpacing && {
    letterSpacing: attrs.letterSpacing * scaleX
  }), attrs.height && {
    height: attrs.height * (attrs.scaleY || defaultScale)
  });
};

export { changeScaleToFontSize, changeScaleToFontSize as default };
